import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { BASE_PUBLIC_API_V2_URL } from '../../public/constants/path.constants';

export default class PublicHttpClient {
  private static axiosInstance?: AxiosInstance;

  private static getInstance(): AxiosInstance {
    if (!PublicHttpClient.axiosInstance) {
      PublicHttpClient.axiosInstance = axios.create({
        baseURL: BASE_PUBLIC_API_V2_URL,
        timeout: 10000,
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
      });
    }

    return PublicHttpClient.axiosInstance;
  }

  static async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await PublicHttpClient.getInstance().get(url, config);

    return response.data;
  }

  static async post<T, D = Record<string, unknown>>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response: AxiosResponse<T> = await PublicHttpClient.getInstance().post(url, data, config);

    return response.data;
  }
}
